// extracted by mini-css-extract-plugin
export default {"wrapper":"WB1WsD0G","text":"XpVDaYdV","name":"JXn5tO5I","description":"k93k8BPx","reasonInput":"TRvLZ8Z9","actions":"Alg3oPLf","alertName":"Z3o7xoSB"};